import { find } from 'lodash'

const remarks = [
	{
		id: 2,
		code: 1,
		plot: 'square',
		color: 'blue'
	}, {
		id: 4,
		code: 3,
		plot: 'diamond',
		color: 'red'
	}, {
		id: 11,
		code: 10,
		plot: 'round',
		color: 'orange'
	}, {
		id: 8,
		code: 7,
		plot: 'triangle',
		color: 'black'
	}
]

const getRemarks = (id) => {
	return find(remarks, (o) => {
		return o.id == id
	})
}

export { remarks, getRemarks }



// WEBPACK FOOTER //
// ./src/utils/AnalysisUtils.js